module.exports = {
  searchForCity: function (city) {
    const options = {
      baseURL: '/_api',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
      params: {
        term: city,
      },
    }
    return this.client.get('/search_for_city/', options)
  },
}
